module.exports = __webpack_public_path__ + "img/another.4ed86c9a.svg";